import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-grade-personalizada-titulo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-3 ant-col-xl-3" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Tipo")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-col",
    style: {"flex":"1 1 auto"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Pessoa")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-3 ant-col-xl-3" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "N.Identificação")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-3 ant-col-xl-3" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Vencimento")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-4 ant-col-xl-4" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Valor do Título")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-4 ant-col-xl-4" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Valor Pago")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-col",
    style: {"flex":"0 0 45px"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Ações")
  ])
], -1)
const _hoisted_2 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_3 = { class: "ss-margin-campos" }
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  class: "ant-col",
  style: {"flex":"1 1 auto"}
}
const _hoisted_6 = { class: "ss-margin-campos" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_9 = { class: "ss-margin-campos" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_12 = { class: "ss-margin-campos" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_15 = { class: "ss-margin-campos" }
const _hoisted_16 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_17 = { class: "ss-margin-campos" }
const _hoisted_18 = {
  class: "ant-col",
  style: {"flex":"0 0 20px"}
}
const _hoisted_19 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_icone = _resolveComponent("icone")!
  const _component_card = _resolveComponent("card")!
  const _component_conta_receber_modal = _resolveComponent("conta-receber-modal")!
  const _component_conta_pagar_modal = _resolveComponent("conta-pagar-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_card, { titulo: " " }, {
      default: _withCtx(() => [
        _hoisted_1,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.titulos, (titulo, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "ant-row ss-grade-personalizada-linha",
            key: index
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("input", {
                  type: "text",
                  class: "ant-input",
                  value: titulo.descricaoTipo,
                  disabled: ""
                }, null, 8, _hoisted_4)
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("input", {
                  type: "text",
                  class: "ant-input",
                  value: titulo.nomePessoa,
                  disabled: ""
                }, null, 8, _hoisted_7)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("input", {
                  type: "text",
                  class: "ant-input",
                  value: titulo.numeroTitulo,
                  disabled: ""
                }, null, 8, _hoisted_10)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("input", {
                  type: "text",
                  class: "ant-input",
                  value: _ctx.UtilitarioData.aplicaFormatoData(titulo.dataVencimento),
                  disabled: ""
                }, null, 8, _hoisted_13)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_campo_numerico, {
                  valor: titulo.valorTotal,
                  monetario: true,
                  disabled: true
                }, null, 8, ["valor"])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_campo_numerico, {
                  valor: titulo.valorPago,
                  monetario: true,
                  disabled: true
                }, null, 8, ["valor"])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", {
                type: "button",
                class: "ant-btn ant-btn-primary ss-botao-remover",
                style: {"width":"100%","padding-top":"6px"},
                title: "Visualizar",
                onClick: ($event: any) => (_ctx.visualizar(titulo.codigoTituloFinanceiro, titulo.tipo))
              }, [
                _createVNode(_component_icone, {
                  class: "ss-icone-remover",
                  nome: "visualizar"
                })
              ], 8, _hoisted_19)
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_component_conta_receber_modal, {
      operacao: _ctx.state.operacaoLancamento,
      visivel: _ctx.state.exibirContaReceber,
      "onUpdate:visivel": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.exibirContaReceber) = $event))
    }, null, 8, ["operacao", "visivel"]),
    _createVNode(_component_conta_pagar_modal, {
      operacao: _ctx.state.operacaoLancamento,
      visivel: _ctx.state.exibirContaPagar,
      "onUpdate:visivel": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.exibirContaPagar) = $event))
    }, null, 8, ["operacao", "visivel"])
  ], 64))
}